import script from "./DefaultModalComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultModalComponent.vue?vue&type=script&setup=true&lang=js"

import "./DefaultModalComponent.vue?vue&type=style&index=0&id=9cb9e95c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cb9e95c"]])

export default __exports__